import { Store } from 'react-notifications-component';
import 'animate.css/animate.min.css';

const defaultProps = {
  color: "white",
  insert: 'bottom',
  container: 'bottom-right',
  animationIn: ['animate__animated', 'animate__fadeIn'],
  animationOut: ['animate__animated', 'animate__zoomOut'],
  dismiss: {
    duration: 6000,
    onScreen: false,
    showIcon: true,
  },
};
export const showWarningNotify = message => {
  Store.addNotification({
    ...defaultProps,
    message,
    type: 'warning',
  });
};

export const showSuccessNotify = message => {
  Store.addNotification({
    ...defaultProps,
    message,
    type: 'success',
  });
};

export const showErrorNotify = message => {
  Store.addNotification({
    ...defaultProps,
    message,
    type: 'danger',
  });
};

